export default __webpack_public_path__ + "static/investment-2d2d803390d0ddc7a815fbaff86c8fd4.jpg";